import React from 'react';
import { FaBookmark, FaChevronDown } from 'react-icons/fa';
import { getModuleTitle } from './openingUtils';

const getModuleId = (module, index) => module?.id || module?._localId || `classic_moment_${index}`;

const FullPageExperience = ({ modules, renderModules, giftIntro = {} }) => {
  const introTitle = giftIntro.title || 'Read the whole gift like one saved story';
  const introCopy = giftIntro.subtitle ||
    'No locks or steps. Just a calm table of contents followed by every chapter in order.';

  const scrollToMoment = (index) => {
    const moduleId = getModuleId(modules[index], index);
    const target = document.querySelector(`[data-module-id="${moduleId}"]`);
    target?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  return (
    <div className="w-full max-w-2xl mx-auto space-y-8">
      <div className="lumirae-opening-card mx-4 backdrop-blur-md">
        <div className="relative min-h-[260px] p-7 text-center">
          <div className="absolute inset-x-8 top-0 h-24 rounded-b-full blur-2xl" style={{ backgroundColor: 'var(--lumirae-accent-soft)' }} />
          <div className="relative mx-auto mb-5 flex h-24 w-20 items-center justify-center rounded-[1.5rem] border border-white shadow-xl" style={{ backgroundColor: 'var(--lumirae-surface-raised)', color: 'var(--lumirae-accent-primary)' }}>
            <FaBookmark className="text-3xl" />
            <div className="absolute -right-4 top-6 h-14 w-8 rounded-r-full border-y-4 border-r-4 border-white bg-white/80" />
          </div>
          <div className="lumirae-opening-label relative">
            Classic Keepsake
          </div>
          <h2 className="lumirae-opening-title relative mx-auto mt-3 max-w-sm text-2xl leading-tight">
            {introTitle}
          </h2>
          <p className="lumirae-opening-copy relative mx-auto mt-3 max-w-xs">
            {introCopy}
          </p>
        </div>

        <div className="border-t p-4" style={{ borderColor: 'var(--lumirae-border-default)', backgroundColor: 'color-mix(in srgb, var(--lumirae-surface-raised) 54%, transparent)' }}>
          <div className="lumirae-ds-meta mb-3 text-center opacity-70">
            Keepsake Index
          </div>
          <div className="grid grid-cols-2 gap-2 sm:grid-cols-3">
          {modules.map((module, index) => (
            <button
              key={getModuleId(module, index)}
              type="button"
              onClick={() => scrollToMoment(index)}
              className="lumirae-opening-pill px-4 py-3 text-left text-[8px] font-black uppercase tracking-widest"
            >
              <span className="block opacity-50">{String(index + 1).padStart(2, '0')}</span>
              <span className="mt-1 block truncate">{getModuleTitle(module, index)}</span>
            </button>
          ))}
          </div>
        </div>

        <div className="lumirae-ds-meta flex items-center justify-center gap-2 border-t py-4" style={{ borderColor: 'var(--lumirae-border-default)' }}>
          <FaChevronDown /> Scroll gently
        </div>
      </div>

      {renderModules(modules, 'full_page')}
    </div>
  );
};

export default FullPageExperience;
